<div class="content" [formGroup]="form">
  <div class="control-container">
    <div class="external-hint">
      {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.SEND_NOTIFICATION_TO' | translate }}
    </div>
    <automata-automation-replacement-chips
      label="AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.USER_TYPES.ADMINS"
      [dataService]="partnerAdminSelectorService"
      [formControl]="usersFormControl"
      [isRequired]="true"
      [supportedDataTypes]="supportedDataTypes"
      (finishedInitialLoading)="finishedInitialLoading()"
    ></automata-automation-replacement-chips>
  </div>

  <automata-send-notification-form
    #notificationForm
    [partnerId]="automation.namespace"
    [step]="step"
    [defaultLinkTemplate]="defaultLinkTemplate"
    [notificationMessagePlaceholderKey]="this.emptyNotificationMessage"
    [userTypeKey]="'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.USER_TYPES.ADMINS'"
  ></automata-send-notification-form>
</div>
